import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'

import router from './router.js'


import VueVideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)

import {Decrypt,Encrypt} from './common/aes/utils.js'


import store from './store'

import VueDND from 'awe-dnd'
Vue.use(VueDND)


import {
	Message
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

// 设置语言
locale.use(lang)
let loading = null
let requestCount = 0
// 顯示loading

function showLoading(){
	if(requestCount===0){
		loading =Message({
			message:'加載中...',
			duration:0
		});
	}

	
	requestCount++
}

function hideLoading(){
	if(requestCount>0){
		requestCount--
	}
	
	if(loading && requestCount===0){
		loading.close()
	}
}


// 添加請求拦截器
axios.interceptors.request.use((config)=>{
    // 在發送請求之前做些什么
	//添加header头的token
	let token = window.sessionStorage.getItem('token')
	if(config.token === true){
		config.headers['token'] = token
	}
	
	
	//顯示loading
	if(config.loading === true){
		showLoading()
	}

    return config;
  },(error)=>{
    // 对請求错误做些什么
	
	//隐藏loading
	hideLoading();
    return Promise.reject(error);
  });

export function commondecrypt(data){
	let en_data = Decrypt(data)
	return en_data
}

// 添加响应拦截器
axios.interceptors.response.use((response) => {

	if(response.config.url!='admin/user/getCaptcha'){
		let en_data = Decrypt(response.data.encryption)
		response.data.encryption = JSON.parse(en_data)
		//console.log(response.data.encryption);
	}
	
	if (response.data.encryption.code != 1) {
		Message.error(response.data.encryption.msg);
	}
	
	response.data = response.data.encryption
	
	if(response.data.errorCode===2001){
		store.commit('logout')
		router.push({
			name: 'login'
		})
	}
	//隐藏loading
	hideLoading();
	
	// 对响应數据做點什么
	return response;
}, (error) => {
	//隐藏loading
	hideLoading();
	
	// 对响应错误做點什么
	return Promise.reject(error);
});



// 引入全局配置
import $conf from './common/config/config.js';
Vue.prototype.$conf = $conf
Vue.config.productionTip = false

Vue.directive('auth',{
	inserted(el,binding,vnode,oldVnode){
		let user = window.sessionStorage.getItem('user')
		user = user ? JSON.parse(user) : {}
		if(user.type!=1){
			let rules = user.ruleNames ? user.ruleNames : []
			let v = rules.find(item=> item === binding.value)
			if(!v){
				el.parentNode.removeChild(el)
			}
		}
	}
})


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
